import "./App.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { lazy, Suspense, useEffect } from "react";

import Header from "./Utils/Header/Header";
import Loader from "./Utils/Loader/Loader";
import ReactPixel from "react-facebook-pixel";
import ReactGA from "react-ga4";
import { useLocation } from "react-router-dom";

// import Product from "./Product/Product";
// import OrderDetail from "./OrderDetail/OrderDetail";
// import OrderFailure from "./OrderStatus/OrderFailure";
// import OrderSuccess from "./OrderStatus/OrderSuccess";

const Home = lazy(() => import(/* webpackChunkName: "Home" */ "./Home/Home"));

const Login = lazy(() => import(/* webpackChunkName: "Login" */ "./Login/Login"));

const About = lazy(() => import(/* webpackChunkName: "About" */ "./About/About"));

const Policy = lazy(() => import(/* webpackChunkName: "Policy" */ "./Policy/Policy"));

const Profile = lazy(() => import(/* webpackChunkName: "Profile" */ "./Profile/Profile"));

const Blog = lazy(() => import(/* webpackChunkName: "Blog" */ "./Blog/Blog"));

const BlogDetails = lazy(() => import(/* webpackChunkName: "BlogDetails" */ "./Blog/BlogDetails"));

const Contact = lazy(() => import(/* webpackChunkName: "Contact" */ "./Contact/Contact"));

const Courses = lazy(() => import(/* webpackChunkName: "Category" */ "./Courses/Courses"));

const Course = lazy(() => import(/* webpackChunkName: "Product" */ "./Course/Course"));

const Cart = lazy(() => import(/* webpackChunkName: "Cart" */ "./Cart/Cart"));

const Checkout = lazy(() => import(/* webpackChunkName: "Checkout" */ "./Checkout/Checkout"));

const ViewLecture = lazy(() => import(/* webpackChunkName: "ViewLecture" */ "./ViewLecture/ViewLecture"));

const OrderDetail = lazy(() => import(/* webpackChunkName: "OrderDetail" */ "./OrderDetail/OrderDetail"));

const OrderSuccess = lazy(() => import(/* webpackChunkName: "OrderSuccess" */ "./OrderStatus/OrderSuccess"));

const OrderFailure = lazy(() => import(/* webpackChunkName: "OrderFailure" */ "./OrderStatus/OrderFailure"));

const TeacherInfo = lazy(() => import(/* webpackChunkName: "TeacherInfo" */ "./TeacherInfo/TeacherInfo"));

const Certificate = lazy(() => import(/* webpackChunkName: "Certificate" */ "./Certficate/Certificate"));

const theme = createTheme({
  palette: {
    primary: {
      main: "#212121",
    },
    secondary: {
      main: "#b10c0a",
    },
    white: {
      main: "#ffffff",
    },
  },
});

// const options = {
//   autoConfig: true, // set to false if you don’t want automatic config
//   debug: false, // set to true to see console logs
// };

// ReactPixel.init("1197608585389279", undefined, options);

ReactGA.initialize("G-B7ZJYJFTW1");

const SuspenseLayout = () => {
  const location = useLocation();

  useEffect(() => {
    ReactPixel.pageView();
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location.pathname, location.search]);
  return (
    <>
      <Header />

      <Suspense
        fallback={
          <div className="loader-container">
            <Loader />
          </div>
        }>
        <Outlet />
      </Suspense>
    </>
  );
};
function App() {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>
          <Route element={<SuspenseLayout />}>
            <Route exact path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/about" element={<About />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/course/:displayURL/:id" element={<Course />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:url" element={<BlogDetails />} />
            <Route path="/policy/:name" element={<Policy />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/view-lecture" element={<ViewLecture />} />
            <Route path="/profile/course/:id" element={<OrderDetail />} />
            <Route path="/pay-success/:id" element={<OrderSuccess />} />
            <Route path="/order-failure/:id" element={<OrderFailure />} />
            <Route path="/teacher/:id" element={<TeacherInfo />} />
            <Route path="/certificate/:certificateId" element={<Certificate />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
